import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useMenuPrincipal } from '../../../../../../../../services/app/providers/menu-principal-provider/menu-principal-provider';
import { EnumMenu } from "../../../../../../../../model";
import { useSessaoAtual } from "../../../../../../../../services/app";
import { useDialog } from "../../../../../../../../services/app/providers/dialog-provider";
import { EnumCodigosPermissoes } from "../../../../../../../../model/enums/enum-codigos-permissoes";

export const useAcoesMenu = () => {
  const history = useHistory();
  const { fecharMenu } = useMenuPrincipal();
  const { getPermissaoBoolean } = useSessaoAtual()
  const { abrirSolicitarPermissao } = useDialog()

  const selectAction = useCallback(
    (codigoModulo: number, path: string) => {
      switch (codigoModulo) {
        case EnumMenu.CONCLUIDOSCANCELADOS:
          if (!getPermissaoBoolean(EnumCodigosPermissoes.CONCLUIDOS_CANCELADOS)) {
            abrirSolicitarPermissao({
              cod: EnumCodigosPermissoes.CONCLUIDOS_CANCELADOS,
              acao: async () => {
                history.push(path);
              },
              openned: true,
              cancelAction: () => true,
              label: 'Concluídos e Cancelados',
            })
            break
          }
          history.push(path);
          break
        default:
          history.push(path);
          break;
      }
      fecharMenu();
    },
    [fecharMenu, getPermissaoBoolean, history, abrirSolicitarPermissao]
  );
  return { selectAction: selectAction };
};
